const scrollWithOffset = (element) => {
  const header = document.querySelector('.ODSGlobalHeader-Container');
  const headerOffset = header ? header.offsetHeight / 1.5 : 0;

  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
};

export {
  scrollWithOffset,
};
